import React from 'react';

const PricaPolicy = () => {
  return (
    <div className="p-10 font-regular w-3/4 mx-auto overflow-auto">
      <h2>Privacy Policy for Todoister</h2>
      <p>Effective Date: 13.1.2025</p>
      <p>
        AE-CloudSystems Oy ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains
        how we collect, use, disclose, and safeguard your information when you use the Todoister application and website
        (todoister.com).
      </p>
      <p>By registering for and using our service, you consent to the practices described in this Privacy Policy.</p>
      <h3>Contact Information</h3>
      <div className="p-4">
        <p>Company Name: AE-CloudSystems Oy</p>
        <p>Address: Hiltiäntie 63, 37500 Lempäälä, Finland</p>
        <p>Service Name: Todoister (application and website)</p>
        <p>
          Website:<a href=" https://wwww.todoister.com"> www.todoister.com</a>
        </p>
        {/* <p>Contact: [Insert email or contact details if applicable]</p> */}
      </div>
      <h3>Information We Collect</h3>
      <p>We collect the following personal data when you register for and use Todoister:</p>
      <ul className="list-disc list-inside text-white">
        <li>Name</li>
        <li>Email address</li>
        <li>User ID</li>
      </ul>
      <h3>Purpose and Legal Basis for Data Processing</h3>
      <p>We use your personal data for the essential functions of the service, such as:</p>
      <ul className="list-disc list-inside text-white">
        <li>Account creation and management</li>
        <li>Authentication and access control</li>
      </ul>
      <p>The legal basis for this processing is your consent, which you provide when registering for the service.</p>
      <h3>Data Disclosure to Third Parties</h3>
      <p>We do not share your personal data with third parties for marketing or external purposes.</p>
      <p>However, we use the following service providers for operational purposes:</p>
      <ul className="list-disc list-inside text-white">
        <li>Firebase Auth (authentication management)</li>
        <li>Render (database hosting and infrastructure maintenance)</li>
      </ul>
      <p>
        These providers process data solely to support our service and do not access user information for any other
        purposes.
      </p>
      <h3>Data Retention</h3>
      <p>
        Your personal data is retained for as long as your account remains active. Upon account deletion, all associated
        personal data is removed from our systems.
      </p>
      <h3>Cookies and Analytics</h3>
      <p>
        We use analytics to improve our service and user experience. Analytics tools may collect anonymized usage data,
        such as app interactions, to help us optimize Todoister's performance.
      </p>
      <h3>User Rights</h3>
      <p>As a registered user, you have the right to:</p>
      <ul className="list-disc list-inside text-white">
        <li>Delete your personal data by deleting your account within the service.</li>
        <li>Request information on how your data is used.</li>
      </ul>
      <p>For any privacy-related requests, please contact us using the provided contact information.</p>
      <h3>Data Storage and Transfers</h3>
      <p>
        All personal data is stored and processed within the EU. We do not transfer personal data outside the EU/EEA.
      </p>
      <h3>Data Security</h3>
      <p>We implement robust security measures to protect your data, including:</p>
      <ul className="list-disc list-inside text-white">
        <li>Encrypted communication: All data transfers are encrypted.</li>
        <li>Authentication: Account access is password-protected and managed securely via Firebase Auth.</li>
      </ul>
      <h3>Compliance with GDPR</h3>
      <p>
        Todoister is compliant with the General Data Protection Regulation (GDPR). We are committed to safeguarding your
        rights and ensuring transparency in data processing.
      </p>
      {/* <p>
        If you have any questions or concerns about this Privacy Policy or your data rights, please contact us at
        [Insert Contact Email].
      </p> */}
    </div>
  );
};

export default PricaPolicy;
